import { ScentIcon } from './ScentIcon';

/**
 * author: Michael Irigoyen
 * id B473C27C-5557-4B1F-89F1-46DC7700E73A
 * name scent
 * version: 6.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/scent.svg
 * tags
 */
export const OdorIcon = ScentIcon;
export default OdorIcon